// Reenvia o documento de uma pendência (documento indeferido) pra API de
// Anexo de GEDs — POST /documentos/reenviar, que na mesma transação reabre o
// DocumentosEntregues antigo e resolve a PendenciaRequerimento (ver README da
// api-anexo-ged). tiposAssunto/tipoDocumentoId já vêm resolvidos na própria
// pendência (ver pendenciasService.js, que cruza modeloRequerimentoId e
// tipoDocumentoId com o catálogo de pedidos do portal).

import documentosApi from '../../../services/documentosApi';
import { authService, protocoloService } from '../../../services';
import logger from '../../../utils/logger';

export async function reenviarDocumentoPendencia({ pendencia, file }) {
  if (!pendencia?.tiposAssunto) {
    throw new Error('Não foi possível identificar o tipo deste pedido para reenvio automático.');
  }
  if (!file) {
    throw new Error('Selecione um arquivo para reenviar.');
  }

  const user = authService.getCurrentUser();
  const { usuarioId } = protocoloService.extrairIdsUsuario(user);

  const formData = new FormData();
  formData.append('RequerimentoId', pendencia.requerimentoId);
  if (pendencia.protocoloId) {
    formData.append('protocoloId', pendencia.protocoloId);
  }
  formData.append('tipoAssunto', pendencia.tiposAssunto);
  formData.append('usuarioId', usuarioId);
  formData.append('tipoDocumentoProcesso', pendencia.tipoDocumentoId);
  formData.append('documentoEntregueId', pendencia.documentoEntregueId);
  formData.append('pendenciaRequerimentoId', pendencia.pendenciaId);
  formData.append('arquivos', file);

  try {
    const response = await documentosApi.post('/documentos/reenviar', formData);
    return response.data;
  } catch (error) {
    logger.error('Erro ao reenviar documento da pendência:', error);
    const mensagem = error.response?.data?.error || error.response?.data?.message || error.message;
    throw new Error(mensagem || 'Erro ao reenviar documento');
  }
}
